'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _recompose = require('recompose');

exports.default = (0, _recompose.withState)('selectionMarqueeActive', 'setSelectionMarqueeActive', false); // Lib


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/selection/selectionMarqueeCanvasStateDecorator.js
// module id = 1695
// module chunks = 0